<div
  *ngIf="isImpersonating$ | async"
  class="e11-w-full e11-flex-shrink-0 e11-flex e11-items-center e11-justify-center e11-gap-4 e11-flex-wrap e11-px-4 e11-py-2 e11-bg-skin-warning/10 e11-text-skin-warning e11-border-b e11-border-skin-warning/30"
  role="status"
>
  <span class="e11-flex e11-items-center e11-gap-1 e11-font-primary-demibold">
    <span class="material-symbols-outlined e11-text-lg">visibility</span>
    {{ 'Acting as' | translate }} {{ customerLabel$ | async }}
  </span>

  <span *ngIf="remaining$ | async as remaining" class="e11-tabular-nums"> {{ 'Time remaining' | translate }}: {{ formatRemaining(remaining) }} </span>

  <e11-button value="{{ 'Exit' | translate }}" color="primary" (click)="exit()"></e11-button>
</div>
